/** Identifier of the consent copy version shown at opt-in. Bump when the copy changes. */
export const MARKETING_CONSENT_TEXT_VERSION = "marketing-consent-v1";

export const MARKETING_CONSENT_ITEM_KEY = "marketingConsent" as const;

export interface MarketingConsentData extends Record<string, unknown> {
  optedIn: boolean;
  /** Captured from the session at opt-in. */
  email?: string;
  consentAt: number;
  consentTextVersion: string;
  consentSource: string;
  withdrawnAt?: number;
}
